import { ListItem } from '@cubeyou-team/hx-react-components';
import React, { useCallback } from 'react';

import translations from 'src/lang';
import { RepositoryItem } from 'src/modules/repository/type';
import { MODAL_TYPES } from '../../../components/RepositoryItemActions/constants';
import { CAMPAIGN_STATUS } from '../constants';

const lang = 'en-US';
const translation = translations[lang].REPOSITORY.ACTIONS.AUDIENCE_ACTIVATION;

export class AudienceActivationItemActions {
  isDraft = false;

  constructor(
    private item: RepositoryItem,
    private actions: any,
    private sendEvent: any,
    private openModal: (eventName: keyof typeof MODAL_TYPES) => void,
    private setRepositoryItem: (item: RepositoryItem) => void
  ) {
    this.isDraft = item?.campaign?.status === CAMPAIGN_STATUS.DRAFT;
  }

  private eventHandler(eventName: keyof typeof MODAL_TYPES) {
    this.openModal(eventName);
    this.setRepositoryItem(this.item);
  }

  private createListItem(iconLeft: string, text: string, onClick: () => void) {
    return <ListItem text={text} iconLeft={iconLeft} onClick={onClick} />;
  }

  private handleOpenAudience = useCallback(() => {
    this.actions.edit(this.item);
    this.sendEvent('Workspace');
  }, [this.item, this.actions, this.sendEvent]);

  private deleteAudience = (onDelete: () => {}) =>
    this.createListItem('delete', translation.DELETE, onDelete);

  openCampaign = this.createListItem(
    'icon-play',
    translation.OPEN_CAMPAIGN,
    () => this.eventHandler(MODAL_TYPES.OPEN_CAMPAIGN)
  );

  editCampaign = this.createListItem('edit', translation.EDIT_CAMPAIGN, () =>
    this.eventHandler(MODAL_TYPES.EDIT_CAMPAIGN)
  );

  duplicate = this.createListItem('icon-copy', translation.DUPLICATE, () =>
    this.eventHandler(MODAL_TYPES.DUPLICATE_CAMPAIGN)
  );

  openAudience = this.createListItem(
    'icon-users',
    translation.OPEN_AUDIENCE,
    this.handleOpenAudience
  );

  getActions = (onDelete: () => {}) => {
    const actions = this.isDraft
      ? [this.editCampaign]
      : [this.openCampaign, this.duplicate];

    return [...actions, this.openAudience, this.deleteAudience(onDelete)];
  };
}
